import styled from '@emotion/styled';

export const AZStepPanel = styled.div`
  img {
    width: 100%;
  }
`;
